import '@quasar/extras/material-icons/material-icons.css'
import './styles/quasar.styl'

import ClosePopup from 'quasar/src/directives/ClosePopup.js';import Dialog from 'quasar/src/plugins/Dialog.js';import QAvatar from 'quasar/src/components/avatar/QAvatar.js';import QBadge from 'quasar/src/components/badge/QBadge.js';import QBanner from 'quasar/src/components/banner/QBanner.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';import QCard from 'quasar/src/components/card/QCard.js';import QCardSection from 'quasar/src/components/card/QCardSection.js';import QChip from 'quasar/src/components/chip/QChip.js';import QDialog from 'quasar/src/components/dialog/QDialog.js';import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';import QFooter from 'quasar/src/components/footer/QFooter.js';import QHeader from 'quasar/src/components/header/QHeader.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';import QInput from 'quasar/src/components/input/QInput.js';import QItem from 'quasar/src/components/item/QItem.js';import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';import QLayout from 'quasar/src/components/layout/QLayout.js';import QList from 'quasar/src/components/item/QList.js';import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';import QMenu from 'quasar/src/components/menu/QMenu.js';import QPage from 'quasar/src/components/page/QPage.js';import QPageContainer from 'quasar/src/components/page/QPageContainer.js';import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';import QSlider from 'quasar/src/components/slider/QSlider.js';import QSpace from 'quasar/src/components/space/QSpace.js';import QSpinnerCube from 'quasar/src/components/spinner/QSpinnerCube.js';import QSpinnerGrid from 'quasar/src/components/spinner/QSpinnerGrid.js';import QToggle from 'quasar/src/components/toggle/QToggle.js';import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import Quasar from 'quasar/src/vue-plugin.js';
import Vue from 'vue'

Vue.use(Quasar, {
  config: {},
  components: {
    QMarkupTable,
    QList,
    QItem,
    QChip,
    QBanner,
    QBadge,
    QBtn,
    QBtnGroup,
    QToggle,
    QHeader,
    QBtnDropdown,
    QAvatar,
    QSpinnerGrid,
    QMenu,
    QFooter,
    QToolbar,
    QTooltip,
    QInput,
    QSpace,
    QInnerLoading,
    QIcon,
    QItemSection,
    QItemLabel,
    QPage,
    QCard,
    QCardSection,
    QDialog,
    QToolbarTitle,
    QExpansionItem,
    QLayout,
    QPageContainer,
    QPageSticky,
    QSlider,
    QSpinnerCube
  },
  directives: {
    ClosePopup
  },
  plugins: {
    Dialog
  }
  // lang: require('quasar/lang/en-gb.js'),
})
